import { useMachine } from '@xstate/react'
import { ReadLocationProps } from 'api/locations/readLocation'
import { requestMachine } from 'machines/requestMachine'
import { useLocationsActions } from 'providers'
import { useCallback } from 'react'
import { TeachingLocation } from 'types/location'

export const useReadLocation = (): [
  (id: ReadLocationProps) => void,
  TeachingLocation | undefined,
  boolean,
  string
] => {
  const [state, send] = useMachine(requestMachine)
  const { read: readLocation } = useLocationsActions()

  const read = useCallback(
    (id: ReadLocationProps) => {
      const promise = readLocation(id)
      send('SET_PROMISE', { data: promise })
    },
    [send, readLocation]
  )

  const location = state.matches('success') && state.context.data
  const errorMessage = state.matches('failed') ? state.context.error : ''
  const loading = state.matches('syncing')

  return [read, location, loading, errorMessage]
}
